jQuery( document ).ready(function($) {

    if($('.etapes').length > 0) {
        $('.etapes_link').click(function( e ) {
            $(this).text($(this).text() == 'En savoir plus' ? 'Fermer' : 'En savoir plus');
            $(this).parent().find($('.etapes_info')).slideToggle();
        });
    }
});
  
  